<template>
  <v-card
    v-if="item"
    id="screenContent"
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        hasHeaderOptions
        :title="_getLabel('CLINICAL_HANDOUTS')"
        :breadcrumb="`${_getLabel('CLINICAL_HANDOUTS')} - ${item.name}`"
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <vetalfa-drugs-header
          :isDrugsMode="true"
          :name="item.name"
          :description="getContentTypeName(item.content_type)"
          v-on:resize="_setupScreenSizes()"
          class="vetalfa-max-width mt-4 mb-2 px-2"
        >
        </vetalfa-drugs-header>
      </v-row>
    </div>
    <div ref="screenContent">
      <vetalfa-sections :sections="item.sections"></vetalfa-sections>
      <div class="white" style="height: 200px"></div>
      <v-btn
        large
        color="primary"
        @click="shareHandout"
        fixed
        rounded
        bottom
        class="text-none px-16"
        style="left: 50%; transform: translateX(-50%); bottom: 30px"
        >{{ _getLabel("CLINICAL_HANDOUT_SHARE") }}
      </v-btn>
    </div>
    <vetalfa-ai-content-assistant
      v-if="item"
      :contextData="item"
      pageType="clinicalHandout"
      :pageName="item.name"
    />
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiFormatListBulleted,
} from "@mdi/js";
export default {
  name: "ItemContent",
  components: {},
  computed: {
    ...mapGetters("topics", ["item", "clinicalHandouts"]),
  },
  watch: {
    "$route.query": {
      handler: function ({ fromMenu }) {
        if (fromMenu) {
          this.$router.replace({ query: {} });
          this.fromMenu = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("topics", ["openTopicItem"]),
    ...mapActions("general", ["routeBack", "routePathRedirect"]),
    ...mapMutations("topics", ["setClinicalHandouts"]),
    getContentTypeName(content_type) {
      return this._getLabel(
        {
          1: "SYSTEMIC_DRUGS",
          2: "DERMATOLOGICAL_TOPICS",
          3: "OPTHALMIC_AGENTS",
          4: "DISEASES_AND_TREATMENT",
        }[content_type]
      );
    },
    addItemToSelection({ id }) {
      let updatedSelection = { ...this.clinicalHandouts };
      updatedSelection[id] = true;
      this.setClinicalHandouts(updatedSelection);
    },
    async shareHandout() {
      this.addItemToSelection(this.item);
      if (this.fromMenu) {
        this.routeBack();
      } else {
        this.routePathRedirect({ path: "/handouts" });
      }
    },
  },
  data() {
    return {
      fromMenu: false,
    };
  },
  async mounted() {
    await this.openTopicItem({
      itemId: this.$route.params.id,
      topicId: "clinical_handouts",
    });
    this.$nextTick(() => {
      this._setupScreenSizes(this);
    });
  },
};
</script>
